import * as React from "react"
import { 
  ArrayInput, 
  NumberInput,
  SimpleFormIterator
} from "react-admin"
import { useEffect, useRef } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import { Grid } from "@mui/material"
import isEqual from "lodash/isEqual"; 

const QuantityDiscountsTab = () => {
  const { setValue, getValues } = useFormContext();
  const bulkPrice = useWatch({ name: "bulkPrice" });
  const quantityDiscounts = useWatch({ name: "quantityDiscounts" });

  const preDiscountsRef = useRef([]);

  useEffect(() => {
    const currentDiscounts = quantityDiscounts || [];

    const updatedDiscountPrice = currentDiscounts.map(d => d?.discountPrice || 0);

    if (isEqual(preDiscountsRef.current, updatedDiscountPrice)) return;

    preDiscountsRef.current = updatedDiscountPrice;

    const originalPrice = getValues('bulkPrice')
    currentDiscounts.forEach((item, index) => {
      if (item?.discountPrice && originalPrice && (originalPrice - item.discountPrice) >= 0) {
        const discountPercentage = ((originalPrice - item.discountPrice) / originalPrice) * 100;
        setValue(`quantityDiscounts.${index}.discountPercentage`, discountPercentage.toFixed(2));
      } else {
        setValue(`quantityDiscounts.${index}.discountPercentage`, 0);
        setValue(`quantityDiscounts.${index}.discountPrice`, originalPrice);
      }
    });
  }, [quantityDiscounts, setValue, getValues]);

  return (
    <Grid container width={{ xs: "100%", xl: 900 }} spacing={2}>
      <Grid item xs={12}>
        <ArrayInput source="quantityDiscounts" label="數量折扣規則">
          <SimpleFormIterator inline getItemLabel={index => `#${index + 1}`}> 
            <NumberInput source="minQuantity" label="最小購買數量" />
            <NumberInput source="maxQuantity" label="最大購買數量" />
            <NumberInput source="discountPercentage" label="折扣百分比" readOnly />
            <NumberInput source="discountPrice" label="折扣價" inputProps={bulkPrice ? { max: bulkPrice } : {}} />
            <NumberInput source="leadTimeDays" label="交期天數" />
          </SimpleFormIterator>
        </ArrayInput>
      </Grid>
    </Grid>
  )
}

export default QuantityDiscountsTab;